export const SupportEmail = 'help@standardnotes.com';
export const SupportMailtoUrl = `mailto:${SupportEmail}`;
export const WebsiteUrl = 'https://standardnotes.com';
export const PrivacyPolicyUrl = 'https://standardnotes.com/privacy';
export const HelpUrl = 'https://standardnotes.com/help';
export const HelpSecurityUrl = 'https://standardnotes.com/help/security';
export const HelpOfflineUrl = 'https://standardnotes.com/help/59/can-i-use-standard-notes-totally-offline';
export const FileSafeHelpUrl = 'https://standardnotes.com/filesafe';
export const ForumUrl = 'https://standardnotes.com/forum';
export const DiscordUrl = 'https://standardnotes.com/discord';
export const AppUrl = 'https://app.standardnotes.com';
export const AppHost = 'app.standardnotes.com';
export const LegacyAppUrl = 'https://app.standardnotes.org';
export const LegacyAppHost = 'app.standardnotes.org';
